<template>
  <div class="customer-detail__container">
    <header class="header__container">
      <label class="text__title-1 mb-0">{{
        `${contractIdLabel}: ${customer.idcId}`
      }}</label>
      <label class="text__subtitle-2 mb-0">{{ customer.name }}</label>
    </header>
    <hr />

    <div class="service-detail__container">
      <div class="service-detail__header">
        <label class="text__title-2">Service Detail</label>
        <div class="row">
          <div class="col-12 col-lg-6">
            <label class="text__key-header">NTDC Site:</label>
            <label class="text__value-header pl-lg-21px">
              {{ customer.siteName }}
            </label>
          </div>
          <div class="col-12 col-lg-6 mt-1 mt-lg-0">
            <label class="text__key-header">Contract Start Date:</label>
            <label class="text__value-header">{{ customer.startDate }}</label>
          </div>
        </div>
      </div>
      <div class="service__list">
        <div
          v-for="(service, index) in customer.services"
          :key="index"
          class="service__item__container"
        >
          <div class="service__item">
            <p class="text__service">
              <span> SERVICE </span>
              <span> {{ index + 1 }}</span>
            </p>
            <div class="row">
              <div
                class="col-12 col-lg-6 d-flex flex-start flex-column flex-lg-row"
              >
                <label class="text__key">Service:</label>
                <label class="text__value">{{ service.service || "-" }}</label>
              </div>
              <div
                class="col-12 col-lg-6 mt-1 mt-lg-0 d-flex flex-start flex-column flex-lg-row"
              >
                <label class="text__key">Service Start Date:</label>
                <label class="text__value">
                  {{ service.startDate || "-" }}
                </label>
              </div>
            </div>
            <div class="row mt-1">
              <div
                class="col-12 col-lg-6 d-flex flex-start flex-column flex-lg-row"
              >
                <label class="text__key">Package:</label>
                <label class="text__value">{{ service.package || "-" }}</label>
              </div>
              <div
                class="col-12 col-lg-6 mt-1 mt-lg-0 d-flex flex-start flex-column flex-lg-row"
              >
                <label class="text__key">Quantity:</label>
                <label class="text__value">
                  {{ service.packageQuantity || "-" }}
                </label>
              </div>
            </div>
            <div class="row mt-1">
              <div
                class="col-12 col-lg-6 d-flex flex-start flex-column flex-lg-row"
              >
                <label class="text__key">Contract Period:</label>
                <label class="text__value">{{
                  service.contractPeriod || "-"
                }}</label>
              </div>
              <div
                class="col-12 col-lg-6 mt-1 mt-lg-0 d-flex flex-start flex-column flex-lg-row"
              >
                <label class="text__key">Location:</label>
                <label class="text__value">{{ service.location || "-" }}</label>
              </div>
            </div>
            <div class="row mt-1">
              <div
                class="col-12 col-lg-6 d-flex flex-start flex-column flex-lg-row"
              >
                <label class="text__key">Bundle Network:</label>
                <label class="text__value">{{
                  service.bundleNetwork || "-"
                }}</label>
              </div>
              <div
                class="col-12 col-lg-6 mt-1 mt-lg-0 d-flex flex-start flex-column flex-lg-row"
              >
                <label class="text__key">Domain:</label>
                <label class="text__value">{{ service.domain || "-" }}</label>
              </div>
            </div>

            <div class="row mt-1">
              <div
                class="col-12 col-lg-6 d-flex flex-start flex-column flex-lg-row"
              >
                <label class="text__key">Rack:</label>
                <template v-if="service.rack !== null">
                  <div class="text__value">
                    <div
                      v-for="(rack, index) in service.rack"
                      :key="index"
                      class="rack__container d-flex flex-column gap-12px"
                    >
                      <div class="border rounded p-1">
                        <div class="w-100">{{ rack.name }}</div>
                        <div class="text__key w-100">
                          Location:
                          {{
                            `${rack.building.name}, ${rack.floor.name}, ${rack.room.name}`
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <div v-else class="text__value">-</div>
              </div>
            </div>

            <div
              v-if="service.serviceInformation.length"
              class="mt-2 col-12 col-lg-6 px-0"
            >
              <atom-collapse
                :isVisible="true"
                :isShadow="false"
                :isHeaderPaddingLeft="false"
              >
                <template #header>
                  <label class="text__title-gray mb-0 mr-1">
                    SERVICE INFORMATION
                  </label>
                </template>
                <template>
                  <div class="pr-2">
                    <div
                      v-for="(item, index) in service.serviceInformation"
                      :key="index"
                    >
                      <label class="text__title-3">
                        {{ item.packageItemName }}
                      </label>
                      <ul v-if="item.packageSubItemName.length">
                        <li
                          v-for="(subItem, index) in item.packageSubItemName"
                          :key="index"
                          class="text__list"
                        >
                          {{ subItem }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </template>
              </atom-collapse>
            </div>

            <div
              v-if="service.options.length"
              class="mt-3 col-12 col-lg-6 px-0"
            >
              <atom-collapse
                :isVisible="true"
                :isShadow="false"
                :isHeaderPaddingLeft="false"
              >
                <template #header>
                  <label class="text__title-gray mb-0 mr-1"
                    >ADD-ON PACKAGE</label
                  >
                </template>
                <template>
                  <div class="row">
                    <div class="col-8">
                      <label class="text__title-3">Options</label>
                    </div>
                    <div class="col-4 text-center">
                      <label class="text__title-3">Quantity</label>
                    </div>
                  </div>
                  <div
                    v-for="(option, index) in service.options"
                    :key="index"
                    class="row text__list mt-1"
                  >
                    <div class="col-8 text__list">
                      <span>{{ option.option }}</span>
                    </div>
                    <div class="col-4 text__list text-center">
                      <span>{{ option.quantity }}</span>
                    </div>
                  </div>
                </template>
              </atom-collapse>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr />

    <atom-collapse
      :isVisible="true"
      :isShadow="false"
      :isHeaderPaddingLeft="false"
    >
      <template #header>
        <label class="text__title-gray-underline mb-0 mr-1"
          >Technical Information</label
        >
      </template>
      <template>
        <div class="row mt-1 pr-2">
          <div
            class="col-12 col-lg-6 d-flex flex-start flex-column flex-lg-row"
          >
            <div class="text__key d-flex align-items-start">
              <b-badge pill variant="light-primary" class="badge--style">
                {{ customer.technicalInformation.ipAddress.length || 0 }}
              </b-badge>
              <div>IP Address:</div>
            </div>
            <div
              v-if="customer.technicalInformation.ipAddress.length"
              class="rack__container content-overflow-scroll"
            >
              <div
                v-for="(ip, index) in customer.technicalInformation.ipAddress"
                :key="index"
                class="d-flex flex-column"
                :class="{ 'mt-8px': index > 0 }"
              >
                <label class="text__value-item mb-8px">{{ ip }}</label>
                <div class="rack__line"></div>
              </div>
            </div>
            <div v-else class="text__value">-</div>
          </div>
          <div
            class="col-12 col-lg-6 mt-1 mt-lg-0 d-flex flex-start flex-column flex-lg-row"
          >
            <label class="text__key-2">Other Technical Detail:</label>
            <label class="text__value content-overflow-scroll">{{
              customer.technicalInformation.detail || "-"
            }}</label>
          </div>
        </div>
      </template>
    </atom-collapse>

    <hr />

    <div>
      <label class="text__title-4">Sale/NTDC Contact</label>
      <div class="mt-1 d-flex">
        <div class="img-wrapper my-1 my-sm-0">
          <b-img
            v-if="customer.saleContact.imgUrl"
            :src="customer.saleContact.imgUrl"
            rounded
            class="avatar__size"
          />
          <div v-else class="no-image-container">
            <b-img v-bind="defaultPicture" rounded blank-color="#efefef" />
            <span class="no-image-text font-size-12">No image</span>
          </div>
        </div>
        <div class="ml-2">
          <label class="text__sale-name">{{
            customer.saleContact.name || "-"
          }}</label>
          <div class="d-flex align-items-center mt-1">
            <feather-icon icon="MailIcon" size="10" stroke="#6E6B7B" /><label
              class="text__contact mb-0"
              >{{ customer.saleContact.email || "-" }}</label
            >
          </div>
          <div class="d-flex align-items-center mt-8px">
            <feather-icon icon="PhoneIcon" size="10" stroke="#6E6B7B" /><label
              class="text__contact mb-0"
              >{{ customer.saleContact.phone || "-" }}</label
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BAvatar, BBadge, BImg } from "bootstrap-vue"
import AtomCollapse from "@/components/atoms/AtomCollapse.vue"
import mixins from "@/mixins"

export default {
  name: "OrganismCustomerDetail",
  components: { BAvatar, BImg, BBadge, AtomCollapse },
  mixins: [mixins],
  props: {
    customer: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      defaultPicture: { blank: true, width: 150, height: 150 },
    }
  },
}
</script>

<style lang="scss" scoped>
hr {
  margin-top: 33px;
  margin-bottom: 33px;
  border: 0;
  border-top: 1px solid #ebe9f1;
}

.customer-detail__container {
  padding: 42px 35px;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.06);
}

.header__container {
  display: flex;
  flex-direction: column;
}

.text__title-1 {
  color: #5e5873;
  font-size: 24px;
  font-weight: 600;
}

.text__subtitle-2 {
  margin-top: 18px;
  color: #6e6b7b;
  font-size: 18px;
  font-weight: 400;
}

.text__title-2 {
  color: #5e5873;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 32px;
}

.text__title-3 {
  color: #6e6b7b;
  font-size: 14px;
  font-weight: 600;
}

.text__title-4 {
  color: #5e5873;
  font-size: 18px;
  font-weight: 500;
}

.text__key,
.text__key-2,
.text__key-header {
  margin-right: 4px;
  color: #6e6b7b;
  font-size: 14px;
  font-weight: 400;
}

.text__key {
  width: 150px;
}

.text__key-header {
  width: 150px;
}

.text__key-2 {
  width: 200px;
}

.text__value,
.text__value-header {
  margin-left: 16px;
  color: #6e6b7b;
  font-size: 14px;
  font-weight: 600;
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
}

.text__value {
  width: calc(100% - 21px);
}

.text__value-item {
  color: #6e6b7b;
  font-size: 14px;
  font-weight: 500;
}

.service__list {
  width: 100%;
}

.service__item {
  margin-top: 31px;
  width: 100%;
  border-radius: 6px;
  border: 1px dashed #8d82fd;
  background: #fff;
  padding: 21px 21px 42px 21px;
}

.text__service {
  color: #7367f0;
  font-size: 16px;
  font-weight: 600;
}

.rack__container {
  margin-bottom: 0.5rem;
  width: 100%;
}

.rack__line {
  background: #ebe9f1;
  height: 1px;
  width: calc(100% - 21px);
}

.text__title-gray {
  color: #b9b9c3;
  font-size: 14px;
  font-weight: 500;
}

.text__title-gray-underline {
  color: #b9b9c3;
  font-size: 12px;
  font-weight: 400;
  text-decoration-line: underline;
}

.text__list {
  color: #6e6b7b;
  font-size: 14px;
  font-weight: 400;
}

.avatar__size {
  border-radius: 6px;
  max-width: 150px;
  max-height: 150px;
  object-fit: contain;
}

.text__sale-name {
  color: #7367f0;
  font-size: 14px;
  font-weight: 600;
}

.text__contact {
  color: #6e6b7b;
  font-size: 12px;
  font-weight: 400;
  margin-left: 8px;
}

.mt-8px {
  margin-top: 8px;
}

.mb-8px {
  margin-bottom: 8px;
}

.img-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;
  height: 150px;
  border-radius: 0.357rem;
  background-color: #efefef;
}

.no-image-container {
  position: relative;
  .no-image-text {
    z-index: 2;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.badge--style {
  max-width: 30ch;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 4px;
  margin-bottom: 4px;
}

.content-overflow-scroll {
  max-height: 200px;
  overflow-y: auto;
}

@media (min-width: 992px) {
  .text__key-header {
    width: 150px;
  }

  .text__value,
  .text__value-header {
    margin-left: 0;
    width: calc(100% - 155px);
  }

  .pl-lg-21px {
    padding-left: 21px;
  }

  .rack__line {
    width: 100%;
  }
}
</style>
